import React from 'react';

const ITEMS = [
    {
        icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="3" width="15" height="13" rx="2"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>,
        title: 'Envío gratis',
        sub: 'en compras desde Q899',
    },
    {
        icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/></svg>,
        title: 'Cambios fáciles',
        sub: '30 días sin preguntas',
    },
    {
        icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>,
        title: 'Pago seguro',
        sub: 'tarjeta, efectivo, transferencia',
    },
    {
        icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>,
        title: 'Soporte WhatsApp',
        sub: 'Lun a dom · 9 a 21h',
    },
];

const TrustRow = () => (
    <section className='pt-9 pb-3'>
        <div className='max-w-[1320px] mx-auto px-6'>
            <div className='grid grid-cols-4 gap-[14px] md-lg:grid-cols-2'>
                {ITEMS.map((item, i) => (
                    <div key={i} className='flex items-center gap-[14px] bg-[#faf9f6] border border-[#f1efea] rounded-[16px] px-[18px] py-4'>
                        <div className='w-[42px] h-[42px] rounded-[12px] bg-[#cffafe] text-[#0891b2] flex items-center justify-center flex-shrink-0'>
                            <span className='w-5 h-5 block'>{item.icon}</span>
                        </div>
                        <div>
                            <div className='font-bold text-[#0f172a] text-[14px] leading-tight'>{item.title}</div>
                            <div className='text-[12.5px] text-[#64748b] mt-[2px]'>{item.sub}</div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    </section>
);

export default TrustRow;
